export const ApartmentLandTypes = {
  SHOW_APARTMENT_LAND_DEBT: "SHOW_APARTMENT_LAND_DEBT",
  ADD_LAND_DEBT: "ADD_LAND_DEBT",
};
